export enum HUB_MESSAGES {
  GET_CONFIG = 'GET_CONFIG',
  GET_CHANNEL_NAME = 'GET_CHANNEL_NAME',
  UPDATE_CHANNEL_NAME = 'UPDATE_CHANNEL_NAME',
  CONFIG_UPDATED = 'CONFIG_UPDATED',
  DISCONNECT = 'DISCONNECT',
  DEVICES = 'DEVICES',
}
